import {
  hasAnyRole,
  IAM_EDITOR,
  USER_ADMIN_ACTION_ROLES,
} from '@/shared/guards/roles';
import { useEffectiveRoles } from '@/shared/view-as/use-effective-roles';

/**
 * `true` se o usuário atual pode executar as ações administrativas sobre a
 * pessoa (editar cadastro, criar/ativar/desativar perfil, operações de
 * credencial) — ver `USER_ADMIN_ACTION_ROLES`.
 *
 * O `adminDashboard.iamEditor` cai no `false`: ele entra na página para
 * gerenciar acessos e mais nada. Continuam visíveis para ele a leitura toda, o
 * "Gerenciar vantagens" e o "Histórico" (`GET .../events` é `identity.viewer`).
 *
 * É só UX — o `IdentityAdminController` é a autoridade real.
 */
export function useCanAdministerUser(): boolean {
  return hasAnyRole(useEffectiveRoles(), USER_ADMIN_ACTION_ROLES);
}

/**
 * `true` para o iamEditor que **não** é admin: ele dá acesso às plataformas que
 * administra, pela rota única (`POST /admin/identity/scoped-users`), e só
 * nelas. O admin segue pelas rotas dele — o `SYSTEM_ADMINISTRATOR` passa no
 * `hasAnyRole` como curinga, mas cai no `canAdminister` primeiro.
 */
export function useIsScopedProvisioner(): boolean {
  const roles = useEffectiveRoles();
  return (
    !hasAnyRole(roles, USER_ADMIN_ACTION_ROLES) &&
    hasAnyRole(roles, [IAM_EDITOR])
  );
}
